import { WhyChooseCard } from "./WhyChooseCard";

export { WhyChooseCard };
